// extracted by mini-css-extract-plugin
module.exports = {"icon":"SearchSelect_icon__3nzzp","icon-reverse":"SearchSelect_icon-reverse__1GxOM"};